
const encodeBase64 :any = function (rawString:any) {
    return new Buffer(rawString).toString("base64");
  };
  export default encodeBase64;